module.exports = __webpack_public_path__ + "img/payment_plan_3.d002f69e.png";